/**
 * Money formatting — the ONLY place cents are divided by 100 for display.
 *
 * Per the house rule: money is integer cents end to end; the frontend never
 * computes a price the API stores, and never does money math with floats
 * outside of a clearly-labeled client-side preview (see quoteMath.ts). This
 * util is display-only.
 */
export function centsToUsd(cents: number): string {
  const dollars = cents / 100;
  return dollars.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Parse a dollar-string input ("175", "1,350.00", "") into whole cents.
 * Mirrors quotes/quoteMath.ts's `dollarsToCents` — the frontend never
 * computes a price the API stores, so this is only for turning an editable
 * dollar input into the integer-cents payload at submit time (event costs,
 * payment amounts), never for a persisted computation.
 */
export function dollarsToCents(input: string): number {
  const cleaned = input.replace(/[^0-9.-]/g, "");
  if (cleaned.trim() === "") return 0;
  const value = Number(cleaned);
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * 100);
}

/** Cents -> a plain (non-locale, no currency symbol) numeral for prefilling an editable dollar input. */
export function centsToDollarsInput(cents: number): string {
  return (cents / 100).toFixed(2);
}
